import { useCallback } from "react"
import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import {
  CancelAppointmentInput,
  useCancelAppointmentMutation as cancelAppointmentMutation,
} from "@/modules/patients/services/__generated__/useCancelAppointmentMutation.graphql"

const mutation = graphql`
  mutation useCancelAppointmentMutation($cancelAppointment: CancelAppointmentInput!) {
    cancelAppointment(input: $cancelAppointment) {
      appointment {
        id
        ...PatientAppointmentFragment @relay(mask: false)
      }
    }
  }
`

export function useCancelAppointmentMutation() {
  const [commit] = useMutation<cancelAppointmentMutation>(mutation)

  return useCallback(
    (cancelAppointment: CancelAppointmentInput, onCompleted?: () => void) => {
      commit({
        variables: { cancelAppointment },
        onCompleted: (response) => {
          const data = response?.cancelAppointment
          if (data?.appointment && cancelAppointment.willRelease) {
            window.close()
          }
          onCompleted?.()
        },
      })
    },
    [commit],
  )
}
